import { flatFileServiceProxy } from "../servicePool";
import { apiUrl } from "../_constants/system";
import { getToken } from "../_utils/userSession";
import * as moment from "moment";

export const getFlatFiles = (
  startDate?: moment.Moment,
  endDate?: moment.Moment,
  clientUnitId?: number | null,
  vendorId?: string | null,
  orderId?: number | null,
  skip?: number,
  maxResultCount?: number,
  sorting?: string
) => {
  return flatFileServiceProxy.getFlatFiles(
    skip || 0,
    maxResultCount || 10,
    startDate,
    endDate,
    vendorId || undefined,
    clientUnitId || undefined,
    sorting || "creationTime DESC"
  ).then(response => ({
    items: response.items,
    totalCount: response.totalCount
  }));
};

export const downloadFlatFile = (id: number) => {
  return flatFileServiceProxy.downloadFlatFile(id);
};

export const markFlatFilesAsDownloaded = (flatFileIds: number[]) => {
  return flatFileServiceProxy.markAsDownloaded({ flatFileIds });
};

export const exportFlatFilesToCsv = (flatFileIds: number[]) => {
  const url = `${apiUrl}/api/FlatFileExport/ExportFlatFiles`;
  
  return fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Authorization": `Bearer ${getToken()}`
    },
    body: JSON.stringify({ flatFileIds })
  }).then(response => {
    if (!response.ok) {
      return response.text().then(text => {
        throw new Error(text || "Failed to export flat files");
      });
    }
    
    // Get filename from Content-Disposition header if available
    const contentDisposition = response.headers.get("Content-Disposition");
    let filename = "FlatFiles.csv";
    if (contentDisposition) {
      const filenameMatch = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
      if (filenameMatch && filenameMatch[1]) {
        filename = filenameMatch[1].replace(/['"]/g, "");
      }
    }
    
    return response.blob().then(blob => ({ blob, filename }));
  });
};
